import { render, staticRenderFns } from "./courseType.vue?vue&type=template&id=a7b03612&scoped=true"
import script from "./courseType.vue?vue&type=script&lang=js"
export * from "./courseType.vue?vue&type=script&lang=js"
import style0 from "./courseType.vue?vue&type=style&index=0&id=a7b03612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-load_8f028cf8807308e2a605e975797e53c7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b03612",
  null
  
)

export default component.exports